import Vue from 'vue';
import {
  Icon,
  Button,
  Lazyload,
  NavBar,
  Grid,
  GridItem,
  DropdownMenu,
  DropdownItem,
  Tab,
  Tabs,
  NoticeBar,
  Cell,
  CellGroup,
  Loading,
  Field,
  CountDown,
  Overlay,
  Dialog,
  Toast,
  Empty,
  Swipe,
  SwipeItem,
  Image,
  ActionSheet,
  Popup,
  Sku,
} from 'vant';

Vue.use(Icon);
Vue.use(Button);
Vue.use(Lazyload);
Vue.use(NavBar);
Vue.use(Grid).use(GridItem);
Vue.use(DropdownMenu).use(DropdownItem);
Vue.use(Tab).use(Tabs);
Vue.use(NoticeBar);
Vue.use(Cell).use(CellGroup);
Vue.use(Loading);
Vue.use(Field);
Vue.use(CountDown);
Vue.use(Overlay);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Empty);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Image);
Vue.use(ActionSheet);
Vue.use(Popup);
Vue.use(Sku);
